import React from 'react';

import { WebsiteLink } from 'src/components/common/website-link';
import { getImagePathForClubFacilityIcon } from 'src/helpers/fixed-images/club-facility-icons';
import type { ClubFacilitiesPage } from 'src/models/cms/navigation-menu-content';

import * as styles from './club-facilities-mobile-nav-item.module.scss';

const ClubFacilitiesMobileNavItem = ({ displayText, link, mobileNavIcon }: ClubFacilitiesPage) => (
  <WebsiteLink to={link} className={styles.link}>
    <div className={styles.item}>
      <img
        src={getImagePathForClubFacilityIcon(mobileNavIcon)}
        className={styles.icon}
        alt={displayText}
      />
      <p className={styles.text}>{displayText}</p>
    </div>
  </WebsiteLink>
);

export default ClubFacilitiesMobileNavItem;
